import isProgressive from "./isProgressive";
import isTarget from "./isTarget";

const displayLastName = (organizationName?: string) => (
  !(isTarget(organizationName) || isProgressive(organizationName))
);

export default displayLastName;
